//action that increases and decreases the wizard step
import {
    CHANGE_PREMIUM_SETTINGS_WIZARD_STORE, CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE,
    CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR,
    CHANGE_WIZARD_STEP, FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES, FAILED_TO_POST_PREMIUM_SETTING_WIZARD,
    GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES,
    POST_NEW_PREMIUM_SETTING_WIZARD,
    RECEIVE_POST_PREMIUM_SETTING_WIZARD, RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES, RESET_APPLICATION_PREMIUM,
	GET_COVERAGE_TYPES,
	RECEIVE_COVERAGE_TYPES,
	FAILED_GET_COVERAGE_TYPES
} from "./index";

export function resetApplicationPremium(payload) {
    return {
        type: RESET_APPLICATION_PREMIUM,
        payload: payload
    }
}

export function changeWizardStep(type) {
    return {
        type: CHANGE_WIZARD_STEP,
        payload: type
    }
}

//action that changes the store settings
export function changePremiumSettingsWizardStore(key, value) {
    return {
        type: CHANGE_PREMIUM_SETTINGS_WIZARD_STORE,
        payload: {
            key,
            value
        }
    }
}

//action that changes settings for the combination of damage band and case stage
export function changePremiumSettingsWizardStoreByDamageAndCaseStage(field, value, tableIndex){
    return {
        type: CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE,
        payload: {
            field,
            value,
            tableIndex
        }
    }
}

//action that changes settings for the combination of damage band , case stage and solicitor
export function changePremiumSettingsWizardStoreByDamageCaseStageAndSolicitor(field, value , tableIndex, solicitorIndex){
    return {
        type: CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR,
        payload: {
            field,
            value,
            tableIndex,
            solicitorIndex
        }
    }
}

//action that requests post new premium setting
export function postNewPremiumSettingWizard(sendBody) {
    return {
        type: POST_NEW_PREMIUM_SETTING_WIZARD,
        payload: sendBody
    };
}

//action that receives response from posting new premium setting
export function receivePostPremiumSettingWizard(response) {
    return {
        type: RECEIVE_POST_PREMIUM_SETTING_WIZARD,
        payload: response
    };
}

//action that receives failed response from posting new premium setting
export function failedToPostPremiumSettingWizard(response) {
    return {
        type: FAILED_TO_POST_PREMIUM_SETTING_WIZARD,
        payload: response
    }
}


//action that requests wizard step messages
export function getPremiumSettingsWizardStepMessages() {
    return {
        type: GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES
    };
}

//function that receives the step messages
export function receivePremiumSettingsWizardMessages(messages) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES,
        payload: messages
    };
}

//action that receives failed response from getting premium settings messages
export function failedToGetPremiumSettingsWizardMessages(resposne) {
    return {
        type: FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES,
        payload: resposne
    }
}

export function getCoverageTypes(payload) {
	return {
		type: GET_COVERAGE_TYPES,
		payload
	}
}

//action that receives bad request from getting the premium settings with combination
export function receiveCoverageTypes(response) {
	return {
		type: RECEIVE_COVERAGE_TYPES,
		payload: response
	}
}

//action that receives failed response from getting premium setting with combination
export function failedToGetCoverageTypes(response) {
	return {
		type: FAILED_GET_COVERAGE_TYPES,
		payload: response
	}
}